document.addEventListener('DOMContentLoaded', function() {
  const tryOnDrawer = document.getElementById('cm-tryon-drawer');
  const tryOnButtons = document.querySelectorAll('.tryon-btn');
  
  if (!tryOnDrawer) return;

  tryOnButtons.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      tryOnDrawer.classList.add('is-open');
    });
  });

  const closeBtn = tryOnDrawer.querySelector('.cm-tryon-drawer__close');
  const overlay = tryOnDrawer.querySelector('.cm-tryon-drawer__overlay');

  if (closeBtn) {
    closeBtn.addEventListener('click', () => tryOnDrawer.classList.remove('is-open'));
  }
  
  if (overlay) {
    overlay.addEventListener('click', () => tryOnDrawer.classList.remove('is-open'));
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') tryOnDrawer.classList.remove('is-open');
  });
});